const app_params = {
    basepath: '/opac', 
    version: '10.0.0',
    gaTag: 'G-TAG',
};

export default app_params;